var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAction3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 217,
    height: 189,
    viewBox: "0 0 217 189",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 81.5,
    cy: 92.5,
    r: 81.5,
    fill: "#FFF9E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M204.175 121.696L198.344 51.7109H191.537L182.787 123.64L204.175 121.696Z",
    fill: "#107393"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M135.167 38.748C143.934 38.748 151.041 31.6409 151.041 22.874C151.041 14.107 143.934 7 135.167 7C126.4 7 119.293 14.107 119.293 22.874C119.293 31.6409 126.4 38.748 135.167 38.748Z",
    fill: "#A9CBDA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M163.026 47.6608C173.136 47.6608 181.332 39.4651 181.332 29.3553C181.332 19.2455 173.136 11.0498 163.026 11.0498C152.916 11.0498 144.721 19.2455 144.721 29.3553C144.721 39.4651 152.916 47.6608 163.026 47.6608Z",
    fill: "#A9CBDA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M142.291 51.7105C149.45 51.7105 155.253 45.9069 155.253 38.7478C155.253 31.5887 149.45 25.7852 142.291 25.7852C135.132 25.7852 129.328 31.5887 129.328 38.7478C129.328 45.9069 135.132 51.7105 142.291 51.7105Z",
    fill: "#A9CBDA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7751 61.1117C74.726 61.1117 79.5502 56.2876 79.5502 50.3366C79.5502 44.3857 74.726 39.5615 68.7751 39.5615C62.8242 39.5615 58 44.3857 58 50.3366C58 56.2876 62.8242 61.1117 68.7751 61.1117Z",
    fill: "#A9CBDA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M101.735 70.0163C111.845 70.0163 120.041 61.8206 120.041 51.7108C120.041 41.6009 111.845 33.4053 101.735 33.4053C91.6253 33.4053 83.4297 41.6009 83.4297 51.7108C83.4297 61.8206 91.6253 70.0163 101.735 70.0163Z",
    fill: "#A9CBDA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0056 74.066C88.1647 74.066 93.9683 68.2624 93.9683 61.1033C93.9683 53.9442 88.1647 48.1406 81.0056 48.1406C73.8466 48.1406 68.043 53.9442 68.043 61.1033C68.043 68.2624 73.8466 74.066 81.0056 74.066Z",
    fill: "#A9CBDA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M177.933 41.025C182.945 41.025 187.008 36.9618 187.008 31.9495C187.008 26.9373 182.945 22.874 177.933 22.874C172.921 22.874 168.857 26.9373 168.857 31.9495C168.857 36.9618 172.921 41.025 177.933 41.025Z",
    fill: "#A9CBDA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M193.482 45.7094C195.18 45.7094 196.556 44.3332 196.556 42.6355C196.556 40.9378 195.18 39.5615 193.482 39.5615C191.784 39.5615 190.408 40.9378 190.408 42.6355C190.408 44.3332 191.784 45.7094 193.482 45.7094Z",
    fill: "#A9CBDA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M208.713 174.832V101.602L167.247 131.414V100.309L124.155 130.764V100.309L81.7129 132.382L83.0059 174.832H208.713Z",
    fill: "#107393"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7578 137.57V147.752H115.957V139.294L98.7578 137.57Z",
    fill: "#D9E0A2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M156.772 139.88H133.742V148.915H156.772V139.88Z",
    fill: "#D9E0A2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M174.07 139.88V150.956H195.246V137.57L174.07 139.88Z",
    fill: "#D9E0A2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M117.707 175.035V155.916L142.291 157.372V174.831L117.707 175.035Z",
    fill: "#D9E0A2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M179.803 155.916H158.521V174.831H179.803V155.916Z",
    fill: "#D9E0A2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9707 174.832V165.374L77.0454 168.375L91.3011 165.472L97.1156 168.903L115.958 172.604L130.002 170.099H146.754L156.765 172.075L178.185 168.643L193.482 171.278L204.175 172.335L217 170.099V174.832H70.9707Z",
    fill: "#2C757A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAction3);
export default __webpack_public_path__ + "static/media/action3.708cc24dbe606ded81a5e4a8922c309a.svg";
export { ForwardRef as ReactComponent };